module.exports = __webpack_public_path__ + "home.jpg?5b8857f56c7961b2d5f14c6567cc41d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/home.jpg
// module id = 171
// module chunks = 0